import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery, useQueryClient } from "react-query";

export const CARE_GROUPS_QUERY_KEY = "careGroupsQuery";

export const useCareGroupsQuery = () => {
  return useQuery({
    queryKey: [CARE_GROUPS_QUERY_KEY],
    retry: false,
    queryFn: getAllCareGroups,
    staleTime: Infinity,
    placeholderData: [],
  });
};

export const useCareGroupQuery = (id) => {
  return useQuery({
    queryKey: [CARE_GROUPS_QUERY_KEY],
    retry: false,
    queryFn: getAllCareGroups,
    staleTime: Infinity,
    placeholderData: [],
    select: (careGroups) => careGroups.filter((cg) => cg.id === id)[0]
  });
};

const getAllCareGroups = async () => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "pcmedapi",
    path: "/care-groups",
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
